/**
 * @file Web gallery scroller loader with upsell container.
 */

import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { markUpsellSeen } from '../redux/cart/web-gallery-cart-actions';
import { openModal } from '../../../actions/modal-actions';
import WebGalleryScrollLoaderWithUpsell from '../components/WebGalleryScrollLoaderWithUpsell';

const propTypes = {
  loadMore: PropTypes.func.isRequired,
  shouldLoadMore: PropTypes.bool.isRequired,
  scrollPercentage: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.node, null]),
  loadOnWheel: PropTypes.bool,
  disableUpsell: PropTypes.bool,
  timesToLoadBeforeUpsell: PropTypes.number,
  indicesRendered: PropTypes.array,
  recordsLength: PropTypes.number,
};

const mapStateToProps = ({ webGalleryCart }) => ({
  hasSeenUpsell: webGalleryCart.hasSeenUpsell,
});

const mapDispatchToProps = {
  markUpsellSeen,
  openModal,
};

const WebGalleryScrollLoaderWithUpsellContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
)(WebGalleryScrollLoaderWithUpsell);

WebGalleryScrollLoaderWithUpsellContainer.propTypes = propTypes;

export default WebGalleryScrollLoaderWithUpsellContainer;
